module.exports = __webpack_public_path__ + "da3aaf02d6b8bf03148ffa197d892f73.jpg";